// export const Host = window.location.hostname === "store.zwz.co.in" ? "ZWZ" : "NOD"
export var HOST = '';
export var API_URL = '';
export var HOST_URL = '';

if (process.env.NODE_ENV == 'production') {
  console.log(process.env.NODE_ENV, 'THIS IS Production ENVIRONMENT.');

  if (window.location.hostname === 'store.zwz.co.in') {
    HOST = process.env.REACT_APP_HOST_ZWZ;
    API_URL = process.env.REACT_APP_API_URL_ZWZ;
    HOST_URL = process.env.REACT_APP_HOST_URL_ZWZ;
  } else if (window.location.hostname === 'store.nodbearings.net') {
    HOST = process.env.REACT_APP_HOST_NOD;
    API_URL = process.env.REACT_APP_API_URL_NOD;
    HOST_URL = process.env.REACT_APP_HOST_URL_NOD;
  } else if (window.location.hostname === 'store.gulfworldwide.com') {
    HOST = process.env.REACT_APP_HOST_GWD;
    API_URL = process.env.REACT_APP_API_URL_GWD;
    HOST_URL = process.env.REACT_APP_HOST_URL_GWD;
  } else {
    HOST = 'GWD';
    (API_URL = 'https://api.store.gulfworldwide.com/'),
      (HOST_URL = 'https://store.gulfworldwide.com');
    // HOST = 'GWD';
    // (API_URL =
    //   'https://NOD-ZWZ-Django-Staging-ALB-Rev-150529337.ap-south-1.elb.amazonaws.com'),
    //   (HOST_URL = 'https://store.gulfworldwide.com');
  }
} else {
  console.log(process.env.NODE_ENV, 'This is Development environment');
  if (window.location.hostname === 'zwz.prtouch.com') {
    HOST = process.env.REACT_APP_HOST_ZWZ;
    API_URL = process.env.REACT_APP_API_URL_ZWZ;
    HOST_URL = process.env.REACT_APP_HOST_URL_ZWZ;
  } else if (window.location.hostname === 'nod.prtouch.com') {
    HOST = process.env.REACT_APP_HOST_NOD;
    API_URL = process.env.REACT_APP_API_URL_NOD;
    HOST_URL = process.env.REACT_APP_HOST_URL_NOD;
  } else if (window.location.hostname === 'gwd.prtouch.com') {
    HOST = process.env.REACT_APP_HOST_GWD;
    API_URL = process.env.REACT_APP_API_URL_GWD;
    HOST_URL = process.env.REACT_APP_HOST_URL_GWD;
  } else {
    HOST = 'GWD';
    API_URL = 'http://apinod.prtouch.com:8081/';
    HOST_URL = 'http://nod.prtouch.com:8081/';
  }
}
